<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('user_list') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <router-link to="/user/create" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
            <div class="pull-right">
                <div class="btn-group tool-group" role="group">
                    <button type="button" class="btn btn-default btn-sm" @click="view_type=0" :class="{active:view_type==0}"><i class="fa fa-list-ul" aria-hidden="true"></i></button>
                    <button type="button" class="btn btn-default btn-sm" @click="view_type=1" :class="{active:view_type==1}"><i class="fa fa-th-large" aria-hidden="true"></i></button>
                </div>
            </div>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="text" class="form-control form-control-sm" :placeholder="$t('search')" v-model="query.Text" @keypress.enter="toList"/>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <button type="button" class="btn btn-default btn-sm" @click="toList"><i aria-hidden="true" class="fa fa-search"></i> {{$t('search')}}</button>
                            </div>
                        </div>
                    </div>
                    <div v-if="view_type==0">
                        <table class="table table-bordered table-sm no-bor">
                            <thead>
                                <tr>
                                    <th class="text-center" style="width: 50px;">{{ $t('no') }}</th>
                                    <th>{{ $t('user_name') }}</th> 
                                    <th>{{ $t('display_name') }}</th>
                                    <th>{{ $t('email') }}</th>
                                    <th>{{ $t('phone') }}</th>
                                    <th>{{ $t('user_group')}}</th>
                                    <th style="width: 10px;"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret, index) in records" :key="index">
                                    <td class="text-center">{{index+1}}</td>
                                    <td><router-link :to="{ name: 'user_edit', params: { id: ret.Id } }">{{ret.UserName}}</router-link></td>
                                    <td>{{ret.DisplayName}}</td>
                                    <td>{{ret.Email}}</td>
                                    <td>{{ret.PhoneNumber}}</td>
                                    <td>{{ret.GroupName}}</td>
                                    <td class="table-cell">
                                        <button type="button" class="btn btn-danger btn-table-xs" @click="onReset(ret)"><i class="fa fa-key" aria-hidden="true"></i></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <template v-else>
                        <div class="row">
                            <div v-for="(ret, index) in records" :key="index" class="col-sm-6 col-md-5 col-lg-4 col-xl-3">
                                <div class="kanban font-bat">
                                    <div class="kanban-image">
                                        <img :src="loadImage(ret.Profile)" style="width: 80px; height: 80px;">
                                    </div>
                                    <div class="kanban-content">
                                        <div style="font-size: 14px; font-weight: bold; padding-bottom: 5px;">{{ret.UserName}}</div>
                                        <div>
                                            <div style="padding: 3px 0;">{{$t('name')}}: {{ret.DisplayName }}</div>
                                            <div style="padding: 3px 0;">{{$t('phone')}}: {{ret.PhoneNumber }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                        hide-goto-end-buttons
                        @change="paging($event)"/>
                    </div>      
                </div>
            </div>
        </div>
        <b-modal v-model="show" id="modal-sm" size="sm" :title="$t('change_password')" :hide-footer="true">
            <div class="form-group" :class="{ 'form-group-error': $v.model.PasswordHash.$error }">
                <label class="label-control blue">{{$t('user_password')}}</label>
                <input type="password" class="form-control form-control-sm" v-model="$v.model.PasswordHash.$model" />
            </div>
            <div class="form-group" :class="{ 'form-group-error': $v.model.Verify.$error }">
                <label class="label-control blue">{{$t('user_confirm_password')}}</label>
                <input type="password" class="form-control form-control-sm" v-model="$v.model.Verify.$model" />
            </div>
            <div class="form-group">
                <button type="button" class="btn btn-success btn-sm btn-block" @click="onSave">{{$t('change_password')}}</button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import { required, sameAs, minLength } from 'vuelidate/lib/validators';
export default {
    data: function(){
        return {
            query:{
                Text: '',
                Page: 1,
                Total: 0,
                Limit: 25
            },
            total: 0,
            records:[],
            img: '/img/no-image.svg',
            view_type: 0,
            show: false,
            model: {
                Id: '',
                PasswordHash: '',
                Verify: ''
            }
        }
    },
    validations:{
        model: {
            PasswordHash: {
                required,
                minLength: minLength(6)
            },
            Verify: { 
                sameAsPassword: sameAs('PasswordHash')
            }
        }
    },
    created: function(){
        this.toList();
    },
    methods: {
        toList: function(){
            let loading = this.$loading.show();
            this.$api().post('account/list', this.query).then((res) => {
                if(this.$isValid(res)){
                    this.records = res.data.Data;
                    this.query.Total = res.data.Data.length;
                }
            }).finally(() => { loading.hide(); });
        },
        loadImage(img){
            if(img == null) return this.img;
            else return this.$base() + 'image/profile?id=' + img;
        },
        paging(e){
            this.query.Page = e;
            this.toList();
        },
        onReset(item){
            this.model.Id = item.Id;
            this.$v.model.$reset();
            this.show = true;
        },
        onSave(){
            this.$v.$touch();
            if(!this.$v.$invalid) {
                let loading = this.$loading.show();
                this.$api().post('account/reset/password', this.model).then((res) => {
                    if(this.$isValid(res)){
                        this.model = {
                            Id: '',
                            PasswordHash: '',
                            Verify: ''
                        };
                        this.show = false;
                    }
                }).finally(() => { loading.hide(); });
            }
        }
    }
}
</script>
<style scoped>
    .no-r{
        margin-right: 0 !important;
    }
    .kanban{
        border: 1px solid #ddd;
        background: #fff;
        padding: 8px;
        display: flex;
    }
    .kanban-content{
        margin-left: 10px;
    }
</style>